var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.menuItem.ChildItems || _vm.menuItem.ChildItems.length === 0)?_c('single-menu-item',{attrs:{"menu-item":_vm.menuItem}}):_c('multiple-menu-item',{attrs:{"menu-item":_vm.menuItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }